import MobileNav from '../plugins/searchDropPlugin';
/* eslint-disable */
export default function initSearchDrop() {
	const menuHolder = document.querySelector('body');
	const searchDrop = new MobileNav(menuHolder, {
		activeClass: 'search-active',
		btnOpenerSelector: '.js-search-opener',
		hideOnClickOutside: true,
		outSideSelector: '.js-search-drop',
		outsideClickEvent: ['click', 'touchstart', 'pointerdown', 'focus'],
		onShow() {
			searchDrop.btnOpeners.forEach((btn) => {
				btn.setAttribute('aria-expanded', 'true');
			});
			setTimeout(() => {
				searchDrop.outSideContainer.querySelector('[type="search"]').focus();
			}, 300);
			document.addEventListener('keydown', handleKeyPress);

			const focusableContent = document.querySelector('.search-drop').querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
			const lastFocusableElement = focusableContent[focusableContent.length - 1];
			lastFocusableElement.addEventListener('blur', () => {
				searchDrop.hide();
			});

			if (document.body.API) {
				document.body.API.hideMenu();
			}
		},
		onHide() {
			searchDrop.btnOpeners.forEach((btn) => {
				btn.setAttribute('aria-expanded', 'false');
			});
			searchDrop.btnOpeners[0].focus();
			document.removeEventListener('keydown', handleKeyPress);
			//they are closing the search drop, remove the search query so it doesnt open again on reload
			if (window.location.search) {
				window.location.search = window.location.search
					.split('?')
					.filter((param) => !param.includes(window.ALGOLIA_INDEX_PREFIX))
					.join('?');
			}
		},
	});

	function handleKeyPress(event) {
		const keys = getKeyboardFocusableElements(searchDrop.outSideContainer);
		const firstItem = keys.slice(0)[0];
		const lastItem = keys.slice(-1)[0];
		let currentItem = document.activeElement;

		if (event.shiftKey && event.keyCode == 9) {
			if (currentItem == firstItem) {
				setTimeout(() => {
					lastItem.focus()
				}, 50)
				event.preventDefault();
			}
		} else if (event.key == "Tab") {
			if (currentItem == lastItem) {
				setTimeout(() => {
					firstItem.focus()
				}, 50)
				event.preventDefault();
			}
		} else if (event.key == "Escape") {
			searchDrop.hide();
		}
	}

	function getKeyboardFocusableElements(element = document) {
		return [
			...element.querySelectorAll(
				'a[href], button, input, textarea, select, details,[tabindex]:not([tabindex="-1"])',
			),
		].filter(
			el => !el.hasAttribute('disabled') && !el.getAttribute('aria-hidden'),
		)
	}

	searchDrop.init();
}
